import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import List from "@material-ui/core/List";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import { ListItemText } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Arbitrator from "../../components/Arbitrator";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import UploadDoc from "../../components/UploadDoc";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Grid from '@material-ui/core/Grid';
import { withRouter } from "react-router-dom";
import FolderOpen from "@material-ui/icons/FolderOpen";
import PropTypes from "prop-types";
import DocsListForOnBoarding from '../../containers/NavTabs/DocsListForOnBoarding'
import upload from "../../images/upload.svg";

const styles = (theme) => ({
  root: {
    //width: '100%',
    display: "column",
    alignItem: "center",
  },
  formControl: {
    margin: theme.spacing.unit * 1,
  },
  group: {},
  radio: {
    "&$checked": {
      color: "#B71C1C",
    },
  },
  checked: {},
  progress: {
    /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
    flexDirection: "column",
    margin: theme.spacing.unit * 3,
  },
  button: {
    display: "flex",
    //justifyContent: 'center',
    margin: "0 Auto",
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    paddingBottom: "15px",
    borderRadius: "25px",
    textTransform: 'none',
    // height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },
  inner: {
    position: "absolute",
    zIndex: 1,
  },
});

class UploadDocsForOnBoarding extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    totaluploadFiles: 2,
    files: [],
    reset: false,
    uniqueId: localStorage.getItem("token"),
  };

  componentDidMount() {}

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleOnAddIcon = () => {
    this.setState((state) => ({
      totaluploadFiles: state.totaluploadFiles + 1,
    }));
  };

  handleAddFile = (file, doc_name) => {
    console.log('handleAddFile: doc_name: '+doc_name)
    this.props.addFile(file, doc_name);
  };

  uploadFile = (event) => {
    let file = event.target.files[0];
    if (file) {
      let doc_name = this.state.doc_name;
      this.handleAddFile(file, doc_name);
      this.setState({ file: file, doc_name: doc_name });
    }
  };

  handleResetFile = (filename) => {
    this.props.removeFile(filename);
  };
  handleResetAll = () => {
    this.setState({
      totaluploadFiles: 2,
      files: [],
      reset: true,
    });
  };

  submitHandler = (event) => {
    event.preventDefault();
    let userType = "";
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      userType = "claimant";
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      userType = "respondent";
    }

    this.props.uploadDocs(
      this.props.files,
      this.props.match.params.id,
      userType
    );
    this.handleResetAll();
  };

  toggleReset = () => {
    this.setState((prevState) => ({
      reset: !prevState.reset,
    }));
  };

  render() {
    const { classes, isLoading, arbitrators } = this.props;
    let userType = "";
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      userType = "claimant";
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      userType = "respondent";
    }
    console.log('uploaddocsonboard: '+JSON.stringify(this.props.claimant_docs))
    return (
      <form onSubmit={this.submitHandler}>
        {userType == 'claimant' && <Typography style={{ fontWeight: "bold", color: "#B71C1C", textAlign: "center" }} >
          {this.context.t("respondentWillBeNotified")}
        </Typography>}
        
        <p style={{ textAlign: "center", width: "100%", marginTop: "30px", marginBottom:'20px' }}>
          <Button onClick={()=>{this.props.history.push('/suggestedDocumentList')}} style={{textTransform:'none'}} className={classes.bInput}>
            {" "}
            {this.context.t("recommendedDocuments")}{" "}
          </Button>{" "}
        </p>

        <DocsListForOnBoarding handleChange={this.handleChange} caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}}/>
        
        <div
          style={{
            background: "#6C0E21",
            paddingTop:'20px',
            paddingBottom:'20px'
          }}
        >
          <Typography style={{ color: "white", marginBottom: "20px", marginLeft:'50px' }}>
            {this.context.t(
              "Please input the description before uploading file."
            )}
          </Typography>

          <Grid container
                direction="row"
                justifyContent="center"
                alignItems="center"
                style={{justifyContent:'center'}}
                >
                  {
                    Array.from(Array(this.state.totaluploadFiles).keys()).map(
                        (data, index) => (
                            <Grid item >
                                <UploadDoc
                                  reset={this.state.reset}
                                  toggleReset={this.toggleReset}
                                  key={index}
                                  fileNumber={index + 1}
                                  onAddIconClick={this.handleOnAddIcon}
                                  onAddFile={this.handleAddFile}
                                  onResetFile={this.handleResetFile}
                                  file={this.props.files[index]}
                                  index={index}
                                  total={this.state.totaluploadFiles}
                                />
                            </Grid>
                        )
                    )
                  }
          </Grid>
        </div>
        

        <div className={classes.root} style={{textAlign:'center', marginTop:'20px'}}>
          {/* <div style={{marginTop:'20px', marginBottom:'20px'}}>
            <Button
              color="primary"
              aria-label="Add"
              size="medium"
              className={classes.bInput}
              onClick={this.handleOnAddIcon}
            >
              <AddIcon />
              {this.context.t("Add File")}
            </Button>
          </div> */}
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            //onClick={this.performLogin}
            style={{
              // height: "30px",
              // width: "85px",
              fontSize: "14px",
              marginBottom: "15px",
            }}
          >
            {this.state.submitInProgress && (
              <CircularProgress size={25} thickness={2} />
            )}
            {this.context.t("Upload")}
          </Button>
        </div>
        
        <div style={{ marginBottom: "100px" }}></div>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.uploadDocs.loading,
    files: state.uploadDocs.files,
    userType: state.caseInfo.userType,
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,

    isAuthenticated: state.auth.token !== null,
    userId: state.auth.userId,
    respondent_docs: state.caseInfo.respondent_docs,
    arbitrator_docs: state.caseInfo.arbitrator_docs,
    claimant_docs: state.caseInfo.claimant_docs,
    lang: state.i18nState.lang,
    newAccount: state.caseInfo[`${state.caseInfo.userType}_newAccount`],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
    removeFile: (filename) => dispatch(actions.removeFile(filename)),
    uploadDocs: (files, caseId, userType) =>
      dispatch(actions.uploadDocs(files, caseId, userType)),
  };
};

UploadDocsForOnBoarding.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(UploadDocsForOnBoarding)));
